"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const impermax_config_manager_1 = require("../../config/contracts/impermax-config-manager");
const onchainProposal_1 = __importDefault(require("./onchainProposal"));
class OnchainConfigManager {
    constructor(onchain) {
        this.proposals = {};
        this.cache = {};
        this.getOnchain = () => this.onchain;
        this.onchain = onchain;
    }
    cleanCache() {
        this.cache = {};
        for (const proposalId of Object.keys(this.proposals)) {
            this.proposals[proposalId].cleanCache();
        }
    }
    getConfigManagerContract() {
        if (!this.cache.configManagerContract) {
            const address = impermax_config_manager_1.IMPERMAX_CONFIG_MANAGER[this.onchain.network];
            if (!address) {
                console.error("ImpermaxConfigManager address not found");
                return null;
            }
            this.cache.configManagerContract = this.onchain.getContractHelper().newImpermaxConfigManager(address);
        }
        return this.cache.configManagerContract;
    }
    getProposal(proposalId) {
        if (!this.proposals[proposalId])
            this.proposals[proposalId] = new onchainProposal_1.default(this, proposalId);
        return this.proposals[proposalId];
    }
}
exports.default = OnchainConfigManager;
